import { render, staticRenderFns } from "./ProjectReportView.vue?vue&type=template&id=018af074"
import script from "./ProjectReportView.vue?vue&type=script&lang=js"
export * from "./ProjectReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports